import Div from "@jumbo/shared/Div";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import {
  getAllRawScrapped,
  getAllWastage,
} from "app/redux/actions/inventoryAction";
import { getKcFabricCodeList } from "app/services/apis/ListApi/kcFabricCodeList";
import { getPurchaseOrderList } from "app/services/apis/ListApi/purchaseOrderList";
import { getRakeDetailsList } from "app/services/apis/ListApi/rakeDetailsList";
import { downloadInventoryRawScrapReport } from "app/services/apis/ReportApis/InventoryScrapReport";
import { downloadInventoryWastageReport } from "app/services/apis/ReportApis/InventoryWastageReport";
import { supplierList } from "app/services/apis/supplierList";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const RawScrappedFilter = ({ setInputsRawScrap, search, setPage }) => {
  const [supplierNameList, setSupplierNameList] = useState([]);
  const [kcFabricCode, setKcFabricCode] = useState([]);
  const [rakeDetails, setRakeDetails] = useState([]);
  const [inputs, setInputs] = useState({});
  const [resetAutocomplete, setResetAutocomplete] = useState(false);
  const { rawScrapped, error, TotalPage } = useSelector(
    (state) => state.inventoryReducer
  );

  const [purchaseOrderNo, setPurchaseOrderNo] = useState([]);
  const dispatch = useDispatch();

  const handleFilter = () => {
    dispatch(getAllRawScrapped(search, inputs, 1));
    setPage(1)
    setInputsRawScrap(inputs)
  };

  const handleClear = () => {
    dispatch(getAllRawScrapped(search, "", 1));
    setPage(1)
    setInputs({});
    setInputsRawScrap({});
    setResetAutocomplete((prev) => !prev);
  };

  useEffect(() => {
    (async () => {
      const data = await supplierList();
      if (data?.status == 200) {
        setSupplierNameList(data.data.result);
      }
      setPurchaseOrderNo(await getPurchaseOrderList());
      setKcFabricCode(await getKcFabricCodeList());
      setRakeDetails(await getRakeDetailsList("Raw"));
    })()
  }, []);

  return (
    <>
      <Div sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 3 }}>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">Kennys Fabric Code</Typography>
          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={kcFabricCode || []}
            value={inputs.kc_fabric_code}
            getOptionLabel={(option) => option.kc_fabric_code}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                kc_fabric_code: newValue?.kc_fabric_code
                  ? newValue?.kc_fabric_code
                  : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.kc_fabric_code}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
              // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">Supplier Name</Typography>
          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={supplierNameList || []}
            // value={}
            getOptionLabel={(option) => option.supplier_name}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                supplier_name: newValue?.supplier_name
                  ? newValue?.supplier_name
                  : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.supplier_name}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
              // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">PO No</Typography>

          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={purchaseOrderNo || []}
            // value={}
            getOptionLabel={(option) => option.purchase_order_no}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                purchase_order_no: newValue?.purchase_order_no
                  ? newValue?.purchase_order_no
                  : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.purchase_order_no}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
              // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>

        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">Rack Details</Typography>
          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={rakeDetails || []}
            getOptionLabel={(option) => option}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                raw_rack_details: newValue ? newValue : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
          />
        </Div>
      </Div>

      <Div
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 4,
          justifyContent: "space-between",
        }}
      >
        <Div>
          <Button
            size="small"
            variant="outlined"
            sx={{ p: 1, pl: 4, pr: 4, marginRight: 2 }} // Adjust marginRight for spacing
            onClick={handleFilter}
          >
            Apply
          </Button>
          <Button
            size="small"
            variant="outlined"
            sx={{ p: 1, pl: 4, pr: 4 }}
            onClick={handleClear}
          >
            Clear
          </Button>
        </Div>
        <Button
          disabled={rawScrapped?.length == 0}
          variant="contained"
          onClick={async () => {
            const data = await downloadInventoryRawScrapReport(inputs);
            window.open(data);
          }}
        >
          Export CSV
        </Button>
      </Div>
    </>
  );
};

export default React.memo(RawScrappedFilter);
